import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@material-ui/core';
import SectionCard from 'components/common/SectionCard';
import { getInitials } from 'utils/Helper';
import { useHistory } from 'react-router-dom';

const DashboardPages = ({ pages }) => {
    const history = useHistory();
    const pageActions = (page) => [
        {
            label: `Go to ${page.title}`,
            Icon: 'FolderOpen',
            onClick: () => history.push(`/pages/${page._id}`),
        },
    ];

    return pages.map(
        (page) =>
            page.status === 'published' &&
            !page.parent && (
                <Grid item lg={3} md={4} sm={6} xs={12} key={page._id}>
                    <SectionCard
                        avatar={getInitials(page.title)}
                        title={page.title}
                        content={page.description}
                        actions={pageActions(page)}
                    />
                </Grid>
            )
    );
};

export default DashboardPages;

DashboardPages.propTypes = {
    pages: PropTypes.array.isRequired,
};
